"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../shared");

var _variants = require("./variants");

var _shared2 = _interopRequireDefault(require("./shared"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var H3 = _styledComponents["default"].h3.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "h3__H3",
  componentId: "sc-wn0693-0"
})(["", ";", ";"], _shared2["default"], _variants.h3Variants);

var _default = H3;
exports["default"] = _default;